import { v4 as uuidv4 } from 'uuid';

export const generatedId = (): string => {
  return uuidv4();
};
